export default function getStartIndexForTimeCode(timeSeries: AbstractTimeSeries, lookupTimeCode: number) {
    if (lookupTimeCode < timeSeries.timeCodes[0] || lookupTimeCode > timeSeries.timeCodes[timeSeries.timeCodes.length - 1]) {
        return undefined;
    }
    const index = timeSeries.timeCodes.findIndex(timeCode => timeCode >= lookupTimeCode);
    return -1 === index ? undefined : index;
}
